import { render, staticRenderFns } from "./lkuPinjamanoutstand.vue?vue&type=template&id=288bb3c1&"
import script from "./lkuPinjamanoutstand.vue?vue&type=script&lang=js&"
export * from "./lkuPinjamanoutstand.vue?vue&type=script&lang=js&"
import style0 from "./lkuPinjamanoutstand.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports